import React, { useState } from "react";
import cn from "classnames";
import { Link } from "react-router-dom";
import styles from "./control.module.sass";
import Icon from "../../../../../Icon";
import {ReactComponent as ArchiveSvg} from '../../../../../../media/images/icons/archive.svg'
import {ReactComponent as Trophy} from '../../../../../../media/images/icons/trophy.svg'
import EyeIcon from '../../../../../../media/images/icons/eye.png'

const Control = ({className, access, name, id, appid, archiveStatus, deleteStatus, markerName}) => {

  const [visibleModal, setVisibleModal] = useState(false);
  const [visibleArchiveModal, setVisibleArchiveModal] = useState(false)

  const actions = [
    {
      pathName : `/view-competition-schedule/${appid}/${id}`,
      action: () => console.log("edit"),
    },
    {
      icon: "edit",
      pathName : `/edit-competition-schedule/${appid}/${id}`,
      action: () => console.log("edit"),
    },
    {
      icon : 'trophy',
      pathName : `/competition-result/${appid}/${id}`,
    },
    {
      icon: "trash",
      action:  () => setVisibleModal(true),
    }
  ];

  return (
    <>
      <div className={cn(styles.control, className)}>
      {access ? 
          (actions && actions.slice(0, 1).map((x, index) => {
            return(
              <Link to={x.pathName} state={{id : id, appid : appid, markerName : markerName, archiveStatus : archiveStatus}} className={styles.button} key={index} onClick={x.action}>
                <img src={EyeIcon} width={20} height={20} className={styles.icon} />
              </Link>
            )
          }))
        : 
          (actions && actions.slice(1).map((x, index) => {
            return(
              <Link to={x.pathName} state={{id : id, appid : appid, name: name}} className={styles.button} key={index} onClick={x.action}>
                {x.icon == 'download' ?  <ArchiveSvg /> : x.icon == 'trophy' ? <Trophy /> : <Icon name={x.icon} size="20" className={styles.icon}/>}
              </Link>
            )
          }))
        }  
        {/* {actions.map((x, index) => {
            return(
              <Link to={x.pathName} state={{id : id, appid : appid, markerName : markerName, archiveStatus : archiveStatus}} className={styles.button} key={index} onClick={x.action}>
                {x.icon == 'download' ?  <ArchiveSvg /> : x.icon == 'trophy' ? <Trophy /> : <Icon name={x.icon} size="20" className={styles.icon}/>}
              </Link>
            )
        })} */}
      </div>
    </>
  );
};

export default Control;
